import { render, staticRenderFns } from "./supplyInfo.vue?vue&type=template&id=5ca6225a&scoped=true"
import script from "./supplyInfo.vue?vue&type=script&lang=js"
export * from "./supplyInfo.vue?vue&type=script&lang=js"
import style0 from "./supplyInfo.vue?vue&type=style&index=0&id=5ca6225a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6225a",
  null
  
)

export default component.exports